module.exports = __webpack_public_path__ + "static/media/broker-step4.231598eb.png";